import { Button, Flex, Table, Tbody, Td, Tfoot, Th, Thead, Tr } from '@chakra-ui/react'
import { EmptyTablePlaceholder, TableSkeleton } from 'brokertslib/src/components'
import type { InsuranceParamsGridItem } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useContext } from 'react'
import { Link } from 'react-router-dom'

import { Pagination } from '../../components/Pagination'
import { TableWrapper } from '../../components/TableWrapper'
import { useApp } from '../../hooks/useApp'
import { contractsCarsContext } from '../../pages/carkulka/contracts'
import { contractsTravelContext } from '../../pages/cestovko/contracts'
import { contractsPropertyContext } from '../../pages/chaloupka/contracts'
import { ContractRow } from './ContractRow'

export const useContractsContext = () => {
  const { app } = useApp()

  if (app === 'cestovko')
    return contractsTravelContext

  if (app === 'chaloupka')
    return contractsPropertyContext

  return contractsCarsContext
}

export const ContractsList = ({
  loading,
  contracts,
  withPaginator = false,
}: {
  loading?: boolean
  contracts: Array<InsuranceParamsGridItem>
  withPaginator?: boolean
}) => {
  const { app, product } = useApp()
  const context = useContractsContext()

  const { currentPage, pageSize, totalCount, setCurrentPage, ...rest } = useContext(context)
  loading = loading || rest.loading

  return (
    <TableWrapper>
      <Table cellPadding="0" cellSpacing="0">
        <Thead>
          <Tr>
            <Th>
              <p>Číslo smlouvy</p>
            </Th>

            <Th>
              <p>Číslo nabídky</p>
            </Th>

            <Th>
              <p>Datum zahájení platnosti</p>
              <p>Datum sjednání</p>
            </Th>

            <Th sx={{ px: 0 }}>{/* <!-- Space for initials --> */}</Th>

            <Th sx={{ pl: 0 }}>
              <p>Pojistník</p>
              {[Product.VehicleInsurance, Product.VehicleLeasingInsurance].includes(product!) && <p>Vozidlo</p>}
            </Th>

            <Th>
              <p>Pojišťovna</p>
            </Th>

            {product !== Product.TravelInsurance && (
              <Th>
                <p>Sjednání</p>
              </Th>
            )}

            <Th>{/* <!-- Space for buttons --> */}</Th>
          </Tr>
        </Thead>

        <Tbody>
          <TableSkeleton colSpan={9} rowsCount={pageSize} isLoaded={!loading} rowHeight={10}>
            <EmptyTablePlaceholder text="Žádné nabídky k zobrazení" colSpan={9} >{
              contracts.map((contract) => {
                return <ContractRow key={contract.contractNumber} item={contract} />
              })}
            </EmptyTablePlaceholder>
          </TableSkeleton>
        </Tbody>

        <Tfoot>
          <Tr>
            <Td colSpan={8}>
              {withPaginator && (
                <Flex sx={{ placeContent: 'center' }}>
                  <Pagination totalCount={totalCount} currentPage={currentPage} setCurrentPage={setCurrentPage} maxButtonCount={10} pageSize={pageSize} />
                </Flex>
              )}

              {!withPaginator && (
                <Link to={`/${app}/contracts`}>
                  <Button type="button" variant="outline" size="sm">
                    Více výročí smluv
                  </Button>
                </Link>
              )}
            </Td>
          </Tr>
        </Tfoot>
      </Table>
    </TableWrapper>
  )
}
